import styled from 'styled-components';

export default styled.h4`
  font-family: ${({ theme }) => theme.fonts.bold};
  font-style: normal;
  /* font-weight: 700; */
  font-size: ${({ theme }) => theme.fontSizes.s};
  line-height: 16.8px;
  color: ${({ theme }) => theme.colors.elvitaTrueBlack};
`;
